import React       from 'react';
import values      from '../../../../../../values';
import Context     from '../../../../../../context';

import { IOnSearchUser                                                } from '../../../../../../types/common.interface';
import { useTranslation                                               } from 'react-i18next';
import { CustomDropdownSearch, ResponsiveView, SearchDropDownWithBase } from '../../../../../../components';

import './index.sass';

const Search: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { requestTransaction, setRequestTransaction } = React.useContext(Context.TransactionsScreen);
  const { t } = useTranslation();

  const userArary = [
    { _id: '0', title: 'driver', value: 'DRIVER'    },
    { _id: '1', title: 'parent', value: 'PASSENGER' },
  ]

  const [selectedUser, setSelectedUser] = React.useState(userArary[0]);

  let baseSearch = values.dropdownBaseSearch.TRANSACTION_BASE_SEARCH_2;
  baseSearch = baseSearch.map((item) => ({...item, title: t(item.title),}));

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================


  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onSearch(event: IOnSearchUser) {
    setRequestTransaction({
      ...requestTransaction,
      search2: {
        path : selectedUser.value,
        base : event?.base?.value,
        value: event?.searchedValue,
      },
    });
    return false;
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------ Start UseEffect functions --------------------------------------------

  React.useEffect(() => {
    setRequestTransaction({
      ...requestTransaction,
      search2: {
        ...requestTransaction?.search2,
        path: selectedUser.value,
      }
    })
  }, [selectedUser])

  // ! ------------------------------------------- End UseEffect functions ---------------------------------------------
  // ! =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section>
      <ResponsiveView.Row id='find-transaction-screen-search-container'>
        <ResponsiveView.Column medium={6} small={12}>
          <CustomDropdownSearch
            items={userArary}
            itemName={'title'}
            defaultItem={selectedUser}
            placeHolder={'انتخاب کاربر'}
            onSelectItem={(event: any) => setSelectedUser(event)}
          />
        </ResponsiveView.Column>
        <ResponsiveView.Column medium={6} small={12}>
          <SearchDropDownWithBase
            icon="fa-solid fa-magnifying-glass"
            size="medium-sd"
            onChangeSearch={onSearch}
            baseSearchItems={baseSearch}
            defaultBaseSearch={baseSearch[0]}
          />
        </ResponsiveView.Column>
      </ResponsiveView.Row>

    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default Search;
